import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "✨", key: "dreamSpace" },
  { emoji: "🧘", key: "calmFunctional" },
  { emoji: "🥂", key: "impressGuests" },
  { emoji: "📈", key: "greaterValue" },
]

export default function HomeFutureOutcomePage() {
  return (
    <RadioCardListPage translationKey="homeFutureOutcome" options={OPTIONS} />
  )
}
